/* eslint-disable unicorn/no-keyword-prefix */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable require-await */

import { type Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as qs from 'qs';
import axios from 'axios';
import { type AppState } from 'app/App.store';
import { capitalizeAllFirstLetters } from '@ui-core/utils/capitalizeAllFirstLetters.lib';
import AxiosClient from '@ui-core/config/axiosClient';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
	type ApproveRequest,
	type Filters,
	type RequestListResponse,
} from '../../adminTypes';
import { toastConfig } from '../../../../utils/constants';

export interface AdminPendingRequestsState {
	loadingRequest: boolean;
	wasFetchedRequest: boolean;
	wasFetchedRequestTab: boolean;
	wasFetchedRequestEnterprise: boolean;
	requestResponseData: RequestListResponse;
	errorRequest: boolean;
	errorMessageRequest: string;
	filtersRequest: Filters;
	filtersRequestFetched: boolean;
	loadingApproveRequest: boolean;
	wasFetchedApproveRequest: boolean;
	approveRequestData: Request;
	errorApproveRequest: boolean;
	errorApproveMessageRequest: string;
	loadingReproveRequest: boolean;
	wasFetchedReproveRequest: boolean;
	reproveRequestData: Request;
	errorReproveRequest: boolean;
	errorReproveMessageRequest: string;
	wasFetchedRequestWorkers: string;
	wasFetchedWorkerInitial: boolean;
	requestResponseWorkers: any[];
	requestWorkersAux: any[];
	paginadorStatus: {
		page: number;
		totalUsers: number;
		currentPage: number;
	};
	userWorkersFilters: {
		type: string[];
		functionalities: string[];
		inputSearch: '';
	};
	isFetchedUserWorkersFilters: boolean;
}

export const initialState: AdminPendingRequestsState = {
	loadingRequest: false,
	wasFetchedRequest: false,
	wasFetchedRequestTab: false,
	wasFetchedRequestEnterprise: false,
	requestResponseData: {} as RequestListResponse,
	errorRequest: false,
	errorMessageRequest: '',
	filtersRequest: {} as Filters,
	filtersRequestFetched: false,
	loadingApproveRequest: false,
	wasFetchedApproveRequest: false,
	approveRequestData: {} as Request,
	errorApproveRequest: false,
	errorApproveMessageRequest: '',
	loadingReproveRequest: false,
	wasFetchedReproveRequest: false,
	reproveRequestData: {} as Request,
	errorReproveRequest: false,
	errorReproveMessageRequest: '',
	wasFetchedRequestWorkers: 'pending',
	wasFetchedWorkerInitial: false,
	requestResponseWorkers: [{}],
	requestWorkersAux: [{}],
	paginadorStatus: {
		page: 1,
		totalUsers: 0,
		currentPage: 1,
	},
	userWorkersFilters: {
		type: [],
		functionalities: [],
		inputSearch: '',
	},
	isFetchedUserWorkersFilters: false,
};

export const adminPendingRequestsSlice = createSlice({
	name: 'adminPendingRequests',
	initialState,
	reducers: {
		loadingRequestR: (state) => {
			state.loadingRequest = true;
			state.errorRequest = false;
			state.errorMessageRequest = '';
			state.wasFetchedRequest = true;
			state.wasFetchedRequestTab = true;
			state.wasFetchedApproveRequest = false;
		},
		cleanFetchedRequestTab: (state) => {
			state.wasFetchedRequestTab = false;
		},
		cleanFetchedRequestEnterprise: (state) => {
			state.wasFetchedRequestEnterprise = false;
		},
		requestStatusSuccess: (
			state,
			action: PayloadAction<RequestListResponse>,
		) => {
			state.loadingRequest = false;
			state.wasFetchedRequest = true;
			state.wasFetchedRequestTab = true;
			state.wasFetchedRequestEnterprise = true;
			state.requestResponseData = action.payload;
			state.wasFetchedReproveRequest = false;
		},
		requestStatusError: (state, action: PayloadAction<string>) => {
			state.loadingRequest = false;
			state.errorRequest = true;
			state.errorMessageRequest = action.payload;
		},
		filtersActive: (state, action: PayloadAction<Filters>) => {
			state.filtersRequest = action.payload;
			state.filtersRequestFetched = true;
		},
		filtersClear: (state) => {
			state.filtersRequest = {} as Filters;
			state.filtersRequestFetched = false;
			state.isFetchedUserWorkersFilters = false;
			state.userWorkersFilters = {
				type: [],
				functionalities: [],
				inputSearch: '',
			};
		},
		loadingApproveRequest: (state) => {
			state.loadingApproveRequest = true;
			state.wasFetchedApproveRequest = false;
			state.errorApproveRequest = false;
			state.errorApproveMessageRequest = '';
		},
		approveRequestStatusSuccess: (
			state,
			action: PayloadAction<Request>,
		) => {
			state.loadingApproveRequest = false;
			state.wasFetchedApproveRequest = true;
			state.approveRequestData = action.payload;
		},
		approveRequestStatusError: (state, action: PayloadAction<string>) => {
			state.loadingApproveRequest = false;
			state.errorApproveRequest = true;
			state.errorApproveMessageRequest = action.payload;
		},
		loadingReproveRequest: (state) => {
			state.loadingReproveRequest = true;
			state.wasFetchedReproveRequest = false;
			state.errorReproveRequest = false;
			state.errorReproveMessageRequest = '';
		},
		reproveRequestStatusSuccess: (
			state,
			action: PayloadAction<Request>,
		) => {
			state.loadingReproveRequest = false;
			state.wasFetchedReproveRequest = true;
			state.reproveRequestData = action.payload;
		},
		reproveRequestStatusError: (state, action: PayloadAction<string>) => {
			state.loadingReproveRequest = false;
			state.errorReproveRequest = true;
			state.errorReproveMessageRequest = action.payload;
		},
		requestStatusWorkers: (state, action: PayloadAction<string>) => {
			state.wasFetchedRequestWorkers = action.payload;
			state.wasFetchedWorkerInitial = true;
		},
		requestResponseWorkers: (state, action: PayloadAction<any[]>) => {
			state.requestResponseWorkers = action.payload;
		},
		requestResponseWorkersAux: (state, action: PayloadAction<any[]>) => {
			const newPayLoad = action.payload.map((load: any) => {
				return {
					label: load.nombre,
					value: load.nombre,
				};
			});
			state.requestWorkersAux = newPayLoad;
		},
		paginatorStatus: (state, action: PayloadAction<any>) => {
			state.paginadorStatus = action.payload;
		},
		userWorkersFilter: (state, action: PayloadAction<any>) => {
			state.userWorkersFilters = action.payload;
			state.isFetchedUserWorkersFilters = true;
		},
	},
});

export const {
	loadingRequestR,
	requestStatusSuccess,
	requestStatusError,
	filtersActive,
	filtersClear,
	cleanFetchedRequestTab,
	cleanFetchedRequestEnterprise,
	loadingApproveRequest,
	approveRequestStatusSuccess,
	approveRequestStatusError,
	loadingReproveRequest,
	reproveRequestStatusSuccess,
	reproveRequestStatusError,
	requestStatusWorkers,
	requestResponseWorkers,
	paginatorStatus,
	userWorkersFilter,
	requestResponseWorkersAux,
} = adminPendingRequestsSlice.actions;

export const useAdminPendingRequestsSelector = () =>
	useSelector<AppState, AdminPendingRequestsState>(
		({ [adminPendingRequestsSlice.name]: slice }) => slice,
	);

export const fetchRequestPendingThunk =
	(rut: string, filters: Filters) =>
	async (dispatch: Dispatch): Promise<void> => {
		const axiosApi = AxiosClient(`${process.env.REACT_APP_API_ACHS}`);
		dispatch(loadingRequestR());
		try {
			const rutEnterprise = localStorage.getItem('rutEnterprise');
			const response = await axiosApi.get(`/admin/v1/solicitud/${rut}`, {
				params: filters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				headers: {
					'ms-company-id': `${rutEnterprise}`,
				},
			});
			const requestLinkedBusinessesData: RequestListResponse =
				response.data;
			dispatch(requestStatusSuccess(requestLinkedBusinessesData));
		} catch (error: unknown) {
			if (axios.isAxiosError(error)) {
				dispatch(requestStatusError(error.response?.data.message));
			}
		}
	};

export const setFilters =
	(filters: Filters) =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch(filtersActive(filters));
	};

export const cleanFilters =
	() =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch(filtersClear());
	};

export const cleanRequestFetched =
	() =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch(cleanFetchedRequestTab());
	};

export const cleanRequestEnterprise =
	() =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch(cleanFetchedRequestEnterprise());
	};

export const approveRequest =
	(id: number, body: ApproveRequest, name: string) =>
	async (dispatch: Dispatch): Promise<void> => {
		const rutCompany = localStorage.getItem('rutEnterprise');
		const axiosApi = AxiosClient(`${process.env.REACT_APP_API_ACHS}`);
		dispatch(loadingApproveRequest);
		try {
			const response = await axiosApi.patch(
				`/admin/v1/solicitud/${id}/aprobar`,
				body,
				{
					headers: {
						'ms-company-id': `${rutCompany}`,
					},
				},
			);
			const result: Request = response.data;
			dispatch(approveRequestStatusSuccess(result));
			toast.success(
				`Aceptaste la solicitud de ${capitalizeAllFirstLetters(name)}`,
				toastConfig,
			);
		} catch (error: unknown) {
			if (axios.isAxiosError(error)) {
				dispatch(
					approveRequestStatusError(error.response?.data.message),
				);
			}
		}
	};

export const reproveRequest =
	(id: number, name: string) =>
	async (dispatch: Dispatch): Promise<void> => {
		const axiosApi = AxiosClient(`${process.env.REACT_APP_API_ACHS}`);
		const rut = localStorage.getItem('rutEnterprise');
		dispatch(loadingReproveRequest);
		try {
			const response = await axiosApi.patch(
				`/admin/v1/solicitud/${id}/rechazar`,
				{},
				{
					headers: {
						'ms-company-id': `${rut}`,
					},
				},
			);
			const result: Request = response.data;
			dispatch(reproveRequestStatusSuccess(result));
			toast.success(
				`Eliminaste la solicitud del usuario ${capitalizeAllFirstLetters(
					name,
				)}`,
				toastConfig,
			);
		} catch (error: unknown) {
			if (axios.isAxiosError(error)) {
				toast.error(
					'Eliminación no ejecutada. Vuelva a intentarlo',
					toastConfig,
				);
				dispatch(
					reproveRequestStatusError(error.response?.data.message),
				);
			}
		}
	};

export default adminPendingRequestsSlice.reducer;
